<template>
  <div v-if="$can('viewDocuments', { for: 'User' })" data-testid="page-bookings">
    <h1 class="pb-7">{{ t('Bookings.headline') }}</h1>
    <RouterView />
  </div>
  <AlertBox v-else type="warning" class="mt-5">
    {{ t('PartnerCompany.noPartnerCompany') }}
  </AlertBox>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useRoleRedirect } from '@/services/roleRedirect'
import { $can } from '@/services/roles'

useRoleRedirect('viewDocuments')

const { t } = useI18n()
</script>
